import { createSignal } from "solid-js";

export const [firstSportDetail, setFirstSportDetail] = createSignal("");

export function useFirstSport() {}

const isProductionEnv = process.env.NODE_ENV === "production";

export function initFirstSport(url: string) {
  let newUrl = url;
  const btPath = firstSportDetail();
  if (btPath) {
    // url 拆分 成 /en  /sports 俩段
    const [main, sub] = url.split("/sports");
    newUrl = main + btPath + sub;
  }

  console.log("first-sport-iframe", newUrl);

  const iframe = document.createElement("iframe");
  iframe.src = newUrl;
  iframe.style.display = "block";
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.border = "none";
  iframe.style.overflow = "hidden";
  iframe.style.position = "absolute";
  iframe.style.top = "0";
  iframe.style.zIndex = "1000";
  iframe.id = "first-sport-iframe";

  document.getElementById("sportdiv")?.appendChild(iframe);
}
